const SchoolMobileLinksView = () => {
    return null;
};

export default SchoolMobileLinksView;